import './utils/platformDetect';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT || 'production',
    release: process.env.REACT_APP_RELEASE_VERSION || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/app\.smart-installers\.co\.uk\/api/,
    ],
  });
}

const domain = process.env.REACT_APP_AUTH0_DOMAIN || 'smart-installers.uk.auth0.com';
const audience = process.env.REACT_APP_AUTH0_AUDIENCE || 'https://si-insights-api';

// Detect if tenant route and use appropriate client ID
const isTenantRoute = window.location.pathname.startsWith('/tenant');
const clientId = isTenantRoute
  ? (process.env.REACT_APP_AUTH0_TENANT_CLIENT_ID || 'YOUR_TENANT_CLIENT_ID')
  : (process.env.REACT_APP_AUTH0_CLIENT_ID || 'TsFjCO3ysijgTTLNy3esBkILgcViIHiK');

// Validate required Auth0 config
if (!domain || !clientId || !audience) {
  console.error('Auth0 configuration missing! Please set REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT_ID (or REACT_APP_AUTH0_TENANT_CLIENT_ID for tenant routes), and REACT_APP_AUTH0_AUDIENCE');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: isTenantRoute
            ? window.location.origin + '/tenant'
            : window.location.origin,
          audience: audience,
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
      >
        <Sentry.ErrorBoundary fallback={<p style={{ padding: 20 }}>Something went wrong. The error has been reported — please refresh.</p>}>
          <App />
        </Sentry.ErrorBoundary>
      </Auth0Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
